import * as React from "react";
import {trackShare} from "../../../Controller/Tracking";
import {TrunkCargo, TrunkLoadingController} from "../../../Controller/3DController/TrunkLoadingController";
import { translate } from "../../../Controller/3DController/translateController";
import { isMobile } from "react-device-detect";
import { AR, Bag, Bottle, BoxLarge, BoxMedium, BoxSmall, Close, Star, StarFilled, Text, TrunkBox, TrunkShopping, TrunkTravel } from '../Icons/Icons';

import './TrunkLoading.scss';


interface Props{
    trunkLoadingController:TrunkLoadingController;
    exit:()=>void;
    exporting:boolean;
    onEnterAR:(leaveTrunkOpen:boolean)=>void;
}

interface State{
    travel:boolean,
    shopping:boolean,
    boxes:boolean,
    showMenuInfo: boolean,
    cargo: TrunkCargo,
    menuInfo: {
        bottles?: number,
        bags?: number,
        rating?: number,
        boxS?: number,
        boxM?: number,
        boxL?: number,
    }
}

export class TrunkLoading extends React.Component<Props,State> {

    constructor(props:Props){
       super(props);
       this.state = {
           travel:this.props.trunkLoadingController.currentCargo === TrunkCargo.Travelling,
           shopping:this.props.trunkLoadingController.currentCargo === TrunkCargo.Shopping,
           boxes:this.props.trunkLoadingController.currentCargo === TrunkCargo.Boxes,
           cargo: this.props.trunkLoadingController.currentCargo,
           showMenuInfo: false,
           menuInfo: {}
       }
    }
    
    private async update(cargo?:TrunkCargo){
        if(this.props && this.props.trunkLoadingController){
            let info = await this.props.trunkLoadingController.getTrunkInfo();
            this.setState({
                travel:this.props.trunkLoadingController.currentCargo === TrunkCargo.Travelling,
                shopping:this.props.trunkLoadingController.currentCargo === TrunkCargo.Shopping,
                boxes:this.props.trunkLoadingController.currentCargo === TrunkCargo.Boxes,
                menuInfo: this.props.trunkLoadingController.currentCargo === TrunkCargo.None?this.state.menuInfo:info,
                cargo: cargo || this.state.cargo
            })
        }
    }
    
    componentDidMount(){
        TrunkLoadingController.event.on(TrunkLoadingController.CARGO_CHANGED, this.update.bind(this))
        this.props.trunkLoadingController.getTrunkInfo().then(info => {
            this.setState({menuInfo: info});
        })
    }

    componentWillUnmount(){
        TrunkLoadingController.event.off(TrunkLoadingController.CARGO_CHANGED, this.update.bind(this))
    }

    renderDeliveryInfo() {
        let renderBox = (icon: React.ReactElement, value: number, units: string) => (
            <div className="vw-trunk-menu__info-box-boxes-item">
                <div className="vw-trunk-menu__info-box-boxes-item-info">
                    {icon}
                    <div>{value}</div>
                </div>
                <div className="vw-trunk-menu__info-box-boxes-item-sizes">{units}</div>
            </div>
        );

        if(this.state.menuInfo.boxS === undefined) return;

        return (
            <div className="vw-trunk-menu__info-box">
                <div className="vw-trunk-menu__info-box-boxes">
                    {renderBox(<BoxSmall />, this.state.menuInfo.boxS, '30x20x35')}
                    {renderBox(<BoxMedium />, this.state.menuInfo.boxM, '40x25x25')}
                    {renderBox(<BoxLarge />, this.state.menuInfo.boxL, '60x30x30')}
                </div>
            </div>
        );
    }

    renderTravellingInfo() {
        let renderStar = (filled: boolean) => (
            filled ? <StarFilled /> : <Star />
        );
        let stars = [];
        for(let i = 0; i < 5; i++) {
            stars.push(renderStar(i<this.state.menuInfo.rating))
        }

        return (
            <div className="vw-trunk-menu__info-box">
                <div className="vw-trunk-menu__info-box-travelling">
                    {this.state.menuInfo.rating ? stars : null}
                </div>
            </div>
        );    
    }
    
    renderShoppingInfo() {
        if(this.state.menuInfo.bottles === undefined) return;
        return (
            <div className="vw-trunk-menu__info-box">
                <div className="vw-trunk-menu__info-box-shopping">
                    <div className="vw-trunk-menu__info-box-shopping-item">
                        <div className="vw-trunk-menu__info-box-shopping-item-icon">
                            <Bottle />
                        </div>
                        <div className="vw-trunk-menu__info-box-shopping-item-name">
                            {`${this.state.menuInfo.bottles} ${translate("id_bottles_1.5l")}`}
                        </div>
                    </div>
                    <div className="vw-trunk-menu__info-box-shopping-item">
                        <div className="vw-trunk-menu__info-box-shopping-item-icon">
                            <Bag />
                        </div>
                        <div className="vw-trunk-menu__info-box-shopping-item-name">
                            {`${this.state.menuInfo.bags} ${translate("id_bags_20l")}`}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderInfoMenu() 
    {   
        if(!this.state.showMenuInfo) return null;
        switch (this.state.cargo) {
            case TrunkCargo.Travelling:
                return this.renderTravellingInfo();
            case TrunkCargo.Shopping:
                return this.renderShoppingInfo();
            case TrunkCargo.Boxes:
                return this.renderDeliveryInfo();
            default:
                break;
        }
    }

    render(){
        const travelSupported = this.props.trunkLoadingController.getCurrentModelSupportsCargo(TrunkCargo.Travelling);
        const shoppingSupported = this.props.trunkLoadingController.getCurrentModelSupportsCargo(TrunkCargo.Shopping);
        const boxesSupported = this.props.trunkLoadingController.getCurrentModelSupportsCargo(TrunkCargo.Boxes);

        return(
            <>
                {this.renderInfoMenu()}

                <div className="vw-trunk-menu">
                    <div className="vw-trunk-menu__option-menu">
                        <div
                            className={`vw-trunk-menu__option-menu-item ${this.state.showMenuInfo ? 'active' : ''}`}
                            onClick={() => this.setState({ showMenuInfo: !this.state.showMenuInfo })}
                        >
                            <Text />
                        </div>
                        {travelSupported && <div
                            className={`vw-trunk-menu__option-menu-item ${this.state.travel ? 'selected' : ''}`}
                            onClick={async () => {
                                if (this.props.trunkLoadingController.currentCargo === TrunkCargo.Travelling) {
                                    this.props.trunkLoadingController.loadCargo(TrunkCargo.None, true);
                                    await this.update();
                                } else {
                                    this.props.trunkLoadingController.loadCargo(TrunkCargo.Travelling, true);
                                    await this.update();
                                }
                            }}
                        >
                            <TrunkTravel />
                        </div>}
                        {shoppingSupported && <div
                            className={`vw-trunk-menu__option-menu-item ${this.state.shopping ? 'selected' : ''}`}
                            onClick={async () => {
                                if (this.props.trunkLoadingController.currentCargo === TrunkCargo.Shopping) {
                                    this.props.trunkLoadingController.loadCargo(TrunkCargo.None, true);
                                    await this.update();
                                } else {
                                    this.props.trunkLoadingController.loadCargo(TrunkCargo.Shopping, true);
                                    await this.update();
                                }
                            }}
                        >
                            <TrunkShopping />
                        </div>}
                        {boxesSupported && <div
                            className={`vw-trunk-menu__option-menu-item ${this.state.boxes ? 'selected' : ''}`}
                            onClick={async () => {
                                if (this.props.trunkLoadingController.currentCargo === TrunkCargo.Boxes) {
                                    this.props.trunkLoadingController.loadCargo(TrunkCargo.None, true);
                                    await this.update();
                                } else {
                                    this.props.trunkLoadingController.loadCargo(TrunkCargo.Boxes, true);
                                    await this.update();
                                }
                            }}
                        >
                            <TrunkBox />
                        </div>}
                    </div>

                    <div className="vw-trunk-menu__bottom-menu">
                        <div
                            className="vw-trunk-menu__bottom-menu-button"
                            onClick={this.props.exit}
                        >
                            <Close />
                        </div>

                        {
                            /*isMobile && (this.props.exporting ? (
                                <div className="vw-trunk-menu__bottom-menu-button">
                                    <AR />
                                </div>
                            ) : (
                                <div className="vw-trunk-menu__bottom-menu-button active" onClick={this.onEnterAR}>
                                    <AR />
                                </div>
                            ))*/
                        }
                    </div>
                </div>
            </>
        );
    }

    private onEnterAR = async () => {
        if (this.props.trunkLoadingController.blocked) {
            const waitUntilNotBlocked = async () => {
                return new Promise<void>((resolve) => {
                    const id = setInterval(() => {
                        if (!this.props.trunkLoadingController.blocked) {
                            clearInterval(id);
                            resolve();
                        }
                    }, 100);
                });
            }

            await waitUntilNotBlocked();
        }

        this.props.onEnterAR(true);
    };
}
